import MensajeInternoService from 'src/modules/mensajeInterno/mensajeInternoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import mensajeInternoListActions from '../list/mensajeInternoListActions';

const prefix = 'MENSAJEINTERNO_FORM';

const mensajeInternoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: mensajeInternoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await MensajeInternoService.find(id);
      }

      dispatch({
        type: mensajeInternoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: mensajeInternoFormActions.INIT_ERROR,
      });

      getHistory().push('/mensaje-interno');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: mensajeInternoFormActions.CREATE_STARTED,
      });

      await MensajeInternoService.create(values);

      dispatch({
        type: mensajeInternoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.mensajeInterno.create.success'),
      );

      dispatch(
        mensajeInternoListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: mensajeInternoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: mensajeInternoFormActions.UPDATE_STARTED,
      });

      await MensajeInternoService.update(id, values);

      dispatch({
        type: mensajeInternoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.mensajeInterno.update.success'),
      );

      getHistory().push('/mensaje-interno');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: mensajeInternoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default mensajeInternoFormActions;
